export default __webpack_public_path__ + "static/media/graphql.eb0bb03d.png";